import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
var DeviceApplicationListView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceApplicationListView, _super);
    function DeviceApplicationListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceApplicationListView.prototype, "device", void 0);
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceApplicationListView.prototype, "product", void 0);
    DeviceApplicationListView = tslib_1.__decorate([
        Component
    ], DeviceApplicationListView);
    return DeviceApplicationListView;
}(Vue));
export default DeviceApplicationListView;
